import { Model } from "@vuex-orm/core"
import { notify } from "@/services/notification"

export default class User extends Model {
  static get entity() {
    return "users"
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      email: this.attr(null),
      roles: this.attr([]),
    }
  }

  get possibleRoles() {
    return [
      { text: "Administrateur·ice", value: "admin" },
      { text: "Formateur·ice", value: "teacher" },
      { text: "Stagiaire", value: "intern" },
    ]
  }

  static translateRole(role) {
    switch (role) {
      case "admin":
        return "Administrateur·ice"
      case "teacher":
        return "Formateur·ice"
      case "superadmin":
        return "Super Administrateur·ice"
      case "intern":
        return "Stagiaire"
      default:
        return "Inconnu"
    }
  }

  static getRoleColor(role) {
    switch (role) {
      case "superadmin":
        return "red"
      case "admin":
        return "red"
      case "teacher":
        return "orange"
      case "intern":
        return "green"
      default:
        return "grey"
    }
  }

  static async getOneById(id) {
    return await this.api()
      .get(`/users/${id}`, { dataKey: "data" })
      .catch((error) => {
        notify("error", error.response.data.error || error.response.data.message || "Erreur")
      })
  }

  static async get() {
    return await this.api()
      .get(`/users/`, { dataKey: "data" })
      .catch((error) => {
        notify("error", error.response.data.error ?? "Erreur")
      })
  }

  static async update(data) {
    return await this.api()
      .put(`/users/`, data, { dataKey: "data" })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.error || error.response.data.message || "Erreur")
      })
  }

  static async create(user) {
    return await this.api()
      .post(`/users`, user, { dataKey: "data" })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.error || error.response.data.message || "Erreur")
      })
  }

  static async deleteOneById(id) {
    return await this.api()
      .delete(`/users/${id}`, { delete: id })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.error || error.response.data.message || "Erreur")
      })
  }

  static async resendEmail(userId) {
    return await this.api()
      .post(`/users/${userId}/reset-password`, { dataKey: "data" })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.error ?? "Erreur")
      })
  }
}
